import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlagIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flag"}/>
}
